module.exports = __webpack_public_path__ + "static/media/boat.c2b76319.mp3";